// ── MSAL configuration ──────────────────────────────────────────────────────
// Microsoft Entra (Azure AD) Single Sign-On for this SPA.
//
// Tenant ID and Client ID are PUBLIC values for a SPA — they live in the
// browser bundle. Microsoft's design: security comes from
//   (a) the Entra app's SPA-platform redirect URI allowlist, and
//   (b) "Assignment required = Yes" on the Enterprise App (Option C),
// not from secrecy. No client secret needed — SPAs use PKCE.
//
// redirectUri is derived from window.location.origin so the SAME code works:
//   - Local dev → http://localhost:3000
//   - Production SWA → https://<swa-host>.azurestaticapps.net
// You must register BOTH origins as SPA redirect URIs in the Entra app.
//
// Required env vars (CRA inlines REACT_APP_* at build time):
//   REACT_APP_AAD_TENANT_ID    — the directory (tenant) GUID
//   REACT_APP_AAD_CLIENT_ID    — the application (client) GUID

import { LogLevel } from '@azure/msal-browser';

const TENANT_ID = process.env.REACT_APP_AAD_TENANT_ID || '';
const CLIENT_ID = process.env.REACT_APP_AAD_CLIENT_ID || '';

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: typeof window !== 'undefined' ? window.location.origin : '',
    postLogoutRedirectUri: typeof window !== 'undefined' ? window.location.origin : '',
    navigateToLoginRequestUrl: true,
  },
  cache: {
    // sessionStorage = signed out when tab closes (more secure for shared machines)
    // localStorage   = persists across tabs/restarts (more convenient)
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (process.env.NODE_ENV !== 'development') return;
        // eslint-disable-next-line default-case
        switch (level) {
          case LogLevel.Error:   console.error(`[msal] ${message}`); break;
          case LogLevel.Warning: console.warn(`[msal] ${message}`);  break;
          case LogLevel.Info:    console.info(`[msal] ${message}`);  break;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

// Scopes requested at login. openid+profile+email give us the user's UPN
// and display name in the ID token; that's enough to auto-select the PO.
export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read'],
};

// Sanity check — fail loud at startup if either GUID is missing.
// Helps catch "forgot to set env var" before MSAL produces cryptic errors.
export const isMsalConfigured = !!(TENANT_ID && CLIENT_ID);
